import { CorePasswordChangeView } from '../../../../../core/views';

import template from './index.jst';

class PasswordChangeView extends CorePasswordChangeView {
	get template() {
		return template;
	}

	get className() {
		return "password-change-page password-change-page-fantasy";
	}
}

export default PasswordChangeView;